import React from "react";
import ReactDOM from "react-dom/client";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./index.css";
import App from "App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);
